import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { Address, PhoneNumber } from 'odq-toolbox';

export interface IMemberResidence {
  phone: PhoneNumber;
  phone2: PhoneNumber;
  addressDetail: Address;
  effectiveOn: OdqDateTime;
}

export class MemberResidence implements IMemberResidence {
  id?: string;
  phone: PhoneNumber;
  phone2: PhoneNumber;
  addressDetail: Address;
  effectiveOn: OdqDateTime;
  endingOn?: OdqDateTime;
  public isCurrent?: boolean;
  constructor(residence: IMemberResidence, residenceId?: string) {
    this.phone = residence.phone;
    this.phone2 = residence.phone2;
    this.addressDetail = residence.addressDetail;
    this.effectiveOn = residence.effectiveOn;
    this.id = residenceId;
  }
}

export class MemberResidenceToAdd implements IMemberResidence {
  phone: PhoneNumber;
  phone2: PhoneNumber;
  addressDetail: ResidenceAddress;
  effectiveOn: OdqDateTime;
  municipalityCode?: string;
}
export class MemberResidenceToChange implements IMemberResidence {
  id: string;
  phone: PhoneNumber;
  phone2: PhoneNumber;
  addressDetail: ResidenceAddress;
  effectiveOn: OdqDateTime;
  municipalityCode?: string;
  isCurrent?: boolean;
}

export class ResidenceAddress extends Address {
  constructor(public normalizeId: string) { super(); }
}
